import FacebookIcon from "@mui/icons-material/Facebook";
import Link from "@mui/material/Link";
import { Colors } from "../../../../utilities/styles";

interface Props {
  url: string;
}

export default function FacebookShareButton({url}: Props) {
  const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    url
  )}`;

  return (
    <Link
      href={shareUrl}
      className="fb-xfbml-parse-ignore"
      sx={{ "&:hover": { color: Colors.BlueFacebook } }}
      target="_blank"
      rel="noopener"
      aria-label="Facebook Share Button"
    >
      <FacebookIcon />
    </Link>
  );
}
